import { render } from "./bh-model-card.vue?vue&type=template&id=280b2146&scoped=true"
import script from "./bh-model-card.vue?vue&type=script&lang=js"
export * from "./bh-model-card.vue?vue&type=script&lang=js"

import "./bh-model-card.vue?vue&type=style&index=0&id=280b2146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280b2146"]])

export default __exports__